import React from "react";
import { connect } from "react-redux";
import { setSessionVar } from "../../store/actions";

class ImageThumbnail extends React.Component {
  state = { thumbLoadFailed: false };

  componentDidUpdate(prevProps) {
    if (
      prevProps.src !== this.props.src ||
      prevProps.thumbnailFallbackSrc !== this.props.thumbnailFallbackSrc
    ) {
      this.setState({ thumbLoadFailed: false });
    }
  }

  getMediaType = (src) => {
    if (!src) return 'image';
    const filePath = src.toLowerCase();
    
    if (filePath.indexOf(".mp3") > -1 || filePath.indexOf(".m4a") > -1) {
      return 'audio';
    } else if (filePath.indexOf(".mp4") > -1 || filePath.indexOf(".mov") > -1) {
      return 'video';
    }
    return 'image';
  };

  renderAudio = () => {
    const { src } = this.props;
    return (
      <audio 
        controls 
        src={src} 
        preload="metadata"
      >
        <source src={src} type="audio/m4a" />
        <source src={src} type="audio/mp3" />
        <source src={src} type="audio/mp4" />
        Your browser does not support the audio element.
      </audio>
    );
  };

  renderVideo = () => {
    const { src } = this.props;
    return (
      <video 
        style={{ maxHeight: 150 }} 
        controls 
        src={src}
      >
        <source src={src}></source>
      </video>
    );
  };

  renderImage = () => {
    const { src, largeSrc, onClick, thumbnailFallbackSrc } = this.props;
    const displaySrc =
      this.state.thumbLoadFailed && thumbnailFallbackSrc
        ? thumbnailFallbackSrc
        : src;
    return (
      <img
        alt={"thumbnail"}
        src={displaySrc}
        style={{ maxHeight: 150 }}
        onError={() => {
          if (
            thumbnailFallbackSrc &&
            displaySrc !== thumbnailFallbackSrc
          ) {
            this.setState({ thumbLoadFailed: true });
          }
        }}
        onClick={() =>
          onClick
            ? onClick(displaySrc)
            : (() => {
                this.props.displayImageViewBox();
                this.props.setImageViewBoxSrc(
                  largeSrc || displaySrc
                );
              })()
        }
        className={"thumbnail"}
      />
    );
  };

  render = () => {
    const mediaType = this.getMediaType(this.props.src);
    
    switch (mediaType) {
      case 'audio':
        return this.renderAudio();
      case 'video':
        return this.renderVideo();
      case 'image':
      default:
        return this.renderImage();
    }
  };
}

const mapStateToProps = (state) => ({
  imageSrc: state.session.vars.imageViewBoxSrc,
  display: state.session.vars.showImageViewBox,
});

const mapDispatchToProps = (dispatch) => ({
  displayImageViewBox: () => dispatch(setSessionVar("showImageViewBox", true)),
  setImageViewBoxSrc: (src) => dispatch(setSessionVar("imageViewBoxSrc", src)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageThumbnail);
